import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';
import { profileData } from '../data/mock';

const Footer = () => {
  return (
    <footer className="py-12 px-6 bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
          <div className="text-center md:text-left">
            <p className="text-gray-900 dark:text-white font-semibold text-lg mb-2">
              {profileData.name}
            </p>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              {profileData.hero.tagline}
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <a
              href={profileData.social.github}
              target="_blank"
              rel="noopener noreferrer"
              className="group p-2 rounded-full hover:bg-gray-900 dark:hover:bg-white transition-all duration-300 transform hover:scale-110"
              aria-label="GitHub"
            >
              <Github className="w-5 h-5 text-gray-600 dark:text-gray-400 group-hover:text-white dark:group-hover:text-gray-900 transition-colors duration-300" />
            </a>
            <a
              href={profileData.social.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="group p-2 rounded-full hover:bg-[#0A66C2] transition-all duration-300 transform hover:scale-110"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-5 h-5 text-gray-600 dark:text-gray-400 group-hover:text-white transition-colors duration-300" />
            </a>
            <a
              href={profileData.social.twitter}
              target="_blank"
              rel="noopener noreferrer"
              className="group p-2 rounded-full hover:bg-black dark:hover:bg-white transition-all duration-300 transform hover:scale-110"
              aria-label="X (Twitter)"
            >
              <svg 
                className="w-5 h-5 text-gray-600 dark:text-gray-400 group-hover:text-white dark:group-hover:text-black transition-colors duration-300" 
                viewBox="0 0 24 24" 
                fill="currentColor"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a
              href={`mailto:${profileData.email}`}
              className="group p-2 rounded-full hover:bg-blue-600 transition-all duration-300 transform hover:scale-110"
              aria-label="Email"
            >
              <Mail className="w-5 h-5 text-gray-600 dark:text-gray-400 group-hover:text-white transition-colors duration-300" />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200 dark:border-gray-800 text-center">
          <p className="text-gray-500 dark:text-gray-400 text-sm">
            © {new Date().getFullYear()} {profileData.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;